import agendaAndMeetingAPI from "../../services/agendaAndMeetingAPI";

const appError = {
  applicationError: {
    hasError: true,
    error: [
      "We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
    ]
  }
};

const healthCheckError = {
  serviceError: {
    hasError: true,
    error: [
      "We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
    ]
  }
};
export default {
  healthCheck: ({ commit }) => {
    try {
      agendaAndMeetingAPI
        .healthCheck()
        .then(response => {
          if (response && response.status === 200) {
            return;
          }
        })
        .catch(error => {
          if (error.response?.status === 503) {
            commit("setErrors", {
              maintenanceError: {
                hasError: true,
                error: error.response?.data?.response?.message || ""
              }
            });
          } else {
            commit("setErrors", healthCheckError);
          }
        });
    } catch (error) {
      commit("setErrors", healthCheckError);
    }
  },
  getSubscriptionVerification: ({ commit }, token) => {
    try {
      agendaAndMeetingAPI
        .subscriptionVerification(token)
        .then(response => {
          console.log(response);
          if (response && response.status === 200 && response.data?.success) {
            console.log(response);
            commit("setSubscription", response.data);
            commit("setErrors", {
              subscriptionError: {
                hasError: !response.data.success,
                error: []
              }
            });
          } else {
            commit("setErrors", {
              subscriptionError: {
                hasError: !response.data.success,
                error: response.data.message
              }
            });
          }
        })
        .catch(error => {
          if (error && error.response && error.response.status === 400) {
            commit("setErrors", {
              verificatonError: {
                hasError: true,
                error:
                  " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
              }
            });
          } else if (
            error &&
            error.code === "ECONNABORTED" &&
            error.response &&
            error.response.data
          ) {
            commit("setErrors", {
              timeoutError: {
                hasError: true,
                error:
                  "Request has timed out. Please try again, if issue persists then call our support team"
              }
            });
          } else {
            commit("setErrors", {
              verificatonError: {
                hasError: true,
                error:
                  " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
              }
            });
          }
        });
    } catch (error) {
      console.log(error);
      commit("setErrors", {
        verificatonError: {
          hasError: true,
          error:
            " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
        }
      });
    }
  },
  getUnsubscribeVerification: ({ commit }, token) => {
    try {
      agendaAndMeetingAPI
        .unsubscribeVerification(token)
        .then(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            response.data.success
          ) {
            commit("setUnsubscribe", response.data);
            commit("setErrors", {
              unsubscribeError: {
                hasError: !response.data.success,
                error: []
              }
            });
          } else {
            commit("setErrors", {
              unsubscribeError: {
                hasError: !response.data.success,
                error: response.data.message
              }
            });
          }
        })
        .catch(error => {
          if (
            error &&
            error.response &&
            error.response.status === 400 &&
            error.response.data &&
            error.response.data.errors
          ) {
            commit("setErrors", {
              unsubscribeError: {
                hasError: true,
                error:
                  " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
              }
            });
          } else if (
            error &&
            error.code === "ECONNABORTED" &&
            error.response &&
            error.response.data
          ) {
            commit("setErrors", {
              timeoutError: {
                hasError: true,
                error:
                  "Request has timed out. Please try again, if issue persists then call our support team"
              }
            });
          } else {
            commit("setErrors", {
              unsubscribeError: {
                hasError: true,
                error:
                  " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
              }
            });
          }
        });
    } catch (error) {
      console.log(error);
      commit("setErrors", {
        unsubscribeError: {
          hasError: true,
          error:
            " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
        }
      });
    }
  },
  createSubscription: ({ commit }, payload) => {
    try {
      agendaAndMeetingAPI
        .createSubscription(payload)
        .then(response => {
          if (response && response.status === 200) {
            commit("setCreateSubscriptionResponse", response.data);
          } else {
            commit("setErrors", {
              createSubscriptionError: {
                hasError: !response.data.success,
                error: response.data.message
              }
            });
          }
        })
        .catch(error => {
          if (
            error &&
            error.response &&
            error.response.status === 400 &&
            error.response.data &&
            error.response.data.errors
          ) {
            commit("setErrors", {
              createSubscriptionError: {
                hasError: true,
                error:
                  " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
              }
            });
          } else if (
            error &&
            error.code === "ECONNABORTED" &&
            error.response &&
            error.response.data
          ) {
            commit("setErrors", {
              timeoutError: {
                hasError: true,
                error:
                  "Request has timed out. Please try again, if issue persists then call our support team"
              }
            });
          } else {
            commit("setErrors", {
              createSubscriptionError: {
                hasError: true,
                error:
                  " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
              }
            });
          }
        });
    } catch (error) {
      console.log(error);
      commit("setErrors", {
        createSubscriptionError: {
          hasError: true,
          error:
            " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
        }
      });
    }
  },
  setErrors: ({ commit }, error) => {
    commit("setErrors", error);
  },
  resetCreatedSubscription: ({ commit }) => {
    commit("resetCreatedSubscription");
  }
};
